import { action, observable, makeObservable } from 'mobx';
import { Model, IModelAttributes, attribute, entity } from 'Models/Model';
import * as Models from 'Models/Entities';

export interface IEventBookingDetailEntityAttributes extends IModelAttributes {
	firstName: string;
	lastName: string;
	email: string;
	phone: string;

	alteration?: Models.AlterationEntity | Models.IAlterationEntityAttributes;
}
@entity('EventBookingDetailEntity', 'Event Booking Detail')
export default class EventBookingDetailEntity extends Model implements IEventBookingDetailEntityAttributes {
	/**
	 * Fields to exclude from the JSON serialization in create operations.
	 */
	public static excludeFromCreate: string[] = [];

	/**
	 * Fields to exclude from the JSON serialization in update operations.
	 */
	public static excludeFromUpdate: string[] = [];

	/**
	 * The first name of the person making the event booking.
	 */
	@observable
	@attribute<EventBookingDetailEntity, string>()
	public firstName: string;

	/**
	 * The last name of the person making the event booking.
	 */
	@observable
	@attribute<EventBookingDetailEntity, string>()
	public lastName: string;

	/**
	 * The email address of the person making the event booking.
	 */
	@observable
	@attribute<EventBookingDetailEntity, string>()
	public email: string;

	/**
	 * The phone number of the person making the event booking.
	 */
	@observable
	@attribute<EventBookingDetailEntity, string>()
	public phone: string;

	@observable
	@attribute({ isReference: true, manyReference: false })
	public alteration?: Models.AlterationEntity;

	constructor(attributes?: Partial<IEventBookingDetailEntityAttributes>) {
		super(attributes);

		makeObservable(this);

		this.assignAttributes(attributes);
	}

	/**
	 * Assigns fields from a passed in JSON object to the fields in this model.
	 * Any reference objects that are passed in are converted to models if they are not already.
	 * This function is called from the constructor to assign the initial fields.
	 */
	public assignAttributes(attributes?: Partial<IEventBookingDetailEntityAttributes>) {
		super.assignAttributes(attributes);

		if (attributes) {
			if (attributes.firstName !== undefined) {
				this.firstName = attributes.firstName;
			}
			if (attributes.lastName !== undefined) {
				this.lastName = attributes.lastName;
			}
			if (attributes.email !== undefined) {
				this.email = attributes.email;
			}
			if (attributes.phone !== undefined) {
				this.phone = attributes.phone;
			}
			if (attributes.alteration !== undefined) {
				if (attributes.alteration === null) {
					this.alteration = attributes.alteration;
				} else if (attributes.alteration instanceof Models.AlterationEntity) {
					this.alteration = attributes.alteration;
				} else {
					this.alteration = new Models.AlterationEntity(attributes.alteration);
				}
			}
		}
	}
}
